import { render, staticRenderFns } from "./scorelistexam.vue?vue&type=template&id=28f1b59e&"
import script from "./scorelistexam.vue?vue&type=script&lang=js&"
export * from "./scorelistexam.vue?vue&type=script&lang=js&"
import style0 from "./scorelistexam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports